import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';


import { HintModel, HintsService } from './hints.service';
import {takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'hints-component',
  templateUrl: 'hints.component.html',
  styleUrls: ['hints.component.scss'],
})
export class HintsComponent implements OnInit, OnDestroy {
  model: HintModel = {
    defaultHintText: '',
    hintText: '',
    hintExample: '',
    isHintDefault: true,
    hintSubtitle: '',
  };

  private isActive: boolean = true;

  constructor(
    private hintsService: HintsService,
    private ref: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.model = this.hintsService.model;
    this.hintsService.showHintEvent
    .pipe(takeWhile(() => this.isActive))
    .subscribe((model: any) => {
      this.ref.markForCheck();
    });
  }

  ngOnDestroy() {
    this.isActive = false;
    this.model = new HintModel();
  }

}
